import Dexie from "dexie";

const db = new Dexie("VideoCacheDB");
db.version(1).stores({
  videos: "url",
});

export default db;
